import { useMemo, useContext, createContext } from 'react';

import { useCollectionData } from 'src/hooks/useCollectionData';

import { ROLES, COLLECTIONS } from 'src/lib/consts';

import { useAuthContext } from 'src/auth/hooks';

import { type StoreLocation } from 'src/types/store';

const StoreLocationsContext = createContext<{
  data: StoreLocation[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useStoreLocations() {
  return useContext(StoreLocationsContext);
}

export function StoreLocationsProvider({
  children,
  limitUserAccess,
}: {
  children: React.ReactNode;
  limitUserAccess?: boolean;
}) {
  const { user } = useAuthContext();
  const { data, loading, error } = useCollectionData<StoreLocation>({
    collectionName: COLLECTIONS.location,
  });

  const filteredData = useMemo(() => {
    if (limitUserAccess && user?.role === ROLES.MANAGER) {
      return data.filter((location) => user?.approved_locations.includes(location.documentId));
    }

    return data;
  }, [data, limitUserAccess, user]);

  return (
    <StoreLocationsContext.Provider value={{ data: filteredData, loading, error }}>
      {children}
    </StoreLocationsContext.Provider>
  );
}
